<template>
  <ProSpaceRightPanel
    v-if="ids.length > 0"
    :header="header"
    :loading="loading"
    :has-error="hasError"
    @clear="clearPanel"
    @edit="editPanel"
    @delete="deletePanel"
    @show-history="showHistoryPanel"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerClusters">
        <template #header>
          <ProSpaceAction
            v-if="checkEditAccess(cluster)"
            :text="$t('editItemTxt')"
            @click="editPanel"
          />
        </template>
        <ProSpacePanelBlockList :list="content" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
} from "@prospace/prospace-components-library";
import { ClusterService } from "../../../services/ClusterService";
import { mapGetters } from "vuex";
import { getAMorPM } from "@prospace/prospace-components-library/src/lib-assets/mixins/date";
export default {
  name: "ClusterPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    ids: {
      type: Array,
      required: true,
    },
    filterAccessDots: {
      type: Function,
    },
    checkEditAccess: {
      type: Function,
    },
    checkAccess: {
      type: Function,
    },
  },
  data() {
    return {
      cluster: null,
      clusterService: new ClusterService(),
      loading: false,
      hasError: false,
    };
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfoStore/getUserinfo",
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    headerClusters() {
      return {
        title: this.$t("overview"),
        isExpand: false,
      };
    },
    headerBottom() {
      return {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      };
    },
    tabs() {
      return [{ name: this.$t("overview"), isActive: true }];
    },
    header() {
      if (this.cluster) {
        return {
          title: this.cluster.value,
          id: this.ids[0],
          status: this.getStatus(this.cluster.status),
          options: this.getAccessDots(this.options),
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
        cleareble: true,
      };
    },
    content() {
      if (this.cluster) {
        return [
          [
            {
              title: this.$t("code"),
              text: this.cluster.code,
            },
          ],
          [
            {
              title: this.$t("clusterValue"),
              text: this.cluster.value,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.cluster) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.cluster.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.cluster.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text:
                this.getFormatDateTime(this.cluster.createdAt) +
                " " +
                getAMorPM(this.cluster.createdAt, this.userinfo?.timeFormat),
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text:
                this.getFormatDateTime(this.cluster.lastUpdated) +
                " " +
                getAMorPM(this.cluster.lastUpdated, this.userinfo?.timeFormat),
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
  },
  methods: {
    getAccessDots(options) {
      return this.filterAccessDots
        ? this.filterAccessDots(options, this.cluster)
        : options;
    },
    update() {
      this.hasError = false;
      try {
        this.getCluster();
      } catch (e) {
        this.hasError = true;
      }
    },
    getCluster() {
      if (this.ids.length === 1) {
        this.loading = true;
        this.clusterService.get(this.ids[0]).then((res) => {
          this.cluster = res.data;
          this.loading = false;
        });
      }
      this.cluster = null;
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "ACTIVE" ? "success" : "danger",
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
    clearPanel() {
      this.$emit("clear");
    },
    editPanel() {
      this.$emit("edit", this.cluster);
    },
    deletePanel() {
      this.$emit("delete", this.cluster);
    },
    showHistoryPanel() {
      this.$emit("history", this.cluster);
    },
  },
};
</script>

<style scoped></style>
